import { FC, ReactNode } from "react";
import { CheckCircle } from "./CheckCircle";
import { TableRow } from "./TableRow";

interface Props {
  children: ReactNode;
  hasPlus?: boolean;
  hasPremium: boolean;
}

export const PlanRow: FC<Props> = ({ children, hasPlus, hasPremium }) => {
  return (
    <TableRow
      col1={children}
      col2={hasPlus && <CheckCircle />}
      col3={hasPremium && <CheckCircle />}
    />
  );
};
